import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class ReportsService {

  constructor(private apollo: Apollo) {
  }

  locationReport() {
    return this.apollo.mutate({
      mutation: gql`mutation locationReport {
        locationReport {
          success
        }
      }`
    });
  }

  attractionReport() {
    return this.apollo.mutate({
      mutation: gql`mutation attractionReport {
        attractionReport {
          success
        }
      }`
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/reports.service.ts